import { request } from './http';

export async function getAnnualAnalyticalDataSummary(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.filter) {
      queryParams.append('filter', JSON.stringify(params.filter));
    }
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.select) queryParams.append('select', params.select);
    
    return request(`/data/AnnualReclaimedSummary?${queryParams.toString()}`);
  }

export async function createAnnualAnalyticalDataSummary(summaryData) {
    return request('/data/AnnualReclaimedSummary', {
      method: 'POST',
      body: JSON.stringify(summaryData)
    });
  }

export async function updateAnnualAnalyticalDataSummary(id, summaryData) {
    return request(`/data/AnnualReclaimedSummary/${id}`, {
      method: 'PUT',
      body: JSON.stringify(summaryData)
    });
  }

export async function deleteAnnualAnalyticalDataSummary(id) {
    return request(`/data/AnnualReclaimedSummary/${id}`, {
      method: 'DELETE'
    });
  }

export const annualAnalyticalDataSummaryApi = {
  getAnnualAnalyticalDataSummary,
  createAnnualAnalyticalDataSummary,
  updateAnnualAnalyticalDataSummary,
  deleteAnnualAnalyticalDataSummary,
};

